export enum ObjectPropertyType {
    Unknown = 'Unknown',
    Integer = 'Integer',
    BigInt = 'BigInt',
    Float = 'Float',
    String = 'String',
    Text = 'Text',
    Date = 'Date',
    Datetime = 'Datetime',
    Timestamp = 'Timestamp',
    Boolean = 'Boolean',
    Guid = 'Guid',
    Email = 'Email',
    Mobile = 'Mobile',
    Phone = 'Phone',
    ShortString = 'ShortString',
    Zip = 'Zip',
    CreatedAtTimestamp = 'CreatedAtTimestamp',
    UpdatedAtTimestamp = 'UpdatedAtTimestamp',
    Relation = 'Relation',
    Object = 'Object'
}

export const numericObjectPropertyTypes = [ObjectPropertyType.Integer, ObjectPropertyType.BigInt, ObjectPropertyType.Float];

export const dateTimeLikeObjectPropertyTypes = [
    ObjectPropertyType.CreatedAtTimestamp,
    ObjectPropertyType.Date,
    ObjectPropertyType.Datetime,
    ObjectPropertyType.Timestamp,
    ObjectPropertyType.UpdatedAtTimestamp
];

export const stringLikeTypes = [
    ObjectPropertyType.String,
    ObjectPropertyType.Text,
    ObjectPropertyType.Email,
    ObjectPropertyType.ShortString,
    ObjectPropertyType.Zip
];
